module.exports = __webpack_public_path__ + "img/no-account.45fb7743.png";